<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="300"
    @keydown.esc="cancel()"
  >
    <!-- Versione 1-->
    <v-card
      v-if="versione==1"
      :color="background"
      dark
    >
      <v-card-text class="title layout justify-center">
        <div class="pt-2">Attendere...</div>
        <v-progress-circular
          class="ml-4"
          :size="40"
          color="white"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
    </v-card>

    <!-- Versione 2-->
    <v-overlay
      v-else-if="versione==2"
      :value="dialog"
      style="z-index: 9999"
    >
      <v-progress-circular
        indeterminate
        size="64"
        style="z-index: 9999"
      ></v-progress-circular>
    </v-overlay>

    <!-- Versione 3-->
    <v-card
      v-else-if="versione==3"
      :color="background"
      dark
    >
      <v-card-text>
        Attendere...
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>



<script>
import { EventBus } from "./waitEventBus";

export default {
  data() {
    return {
      dialog: false,

      background: "",
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },

    handleWait(tipo) {
      if (tipo == "open") this.open();
      else if (tipo == "close") this.close();
    },
  },

  beforeMount() {
    // Impostazioni
    this.background = this.$waitOptions.background;

    EventBus.$on("WaitOpen", this.handleWait);
  },

  beforeDestroy() {
    EventBus.$off("WaitOpen", this.handleWait);
  },

  computed: {
    versione() {
      return this.$waitOptions.version;
    },
  },
};
</script>